module.exports = __webpack_public_path__ + "static/media/border-all.986a597b.svg";